<template src="./template.html"></template>

<script>
import { mapState } from 'vuex'
import masterMixin from 'src/mixins/masterMixin'

export default {
  displayPageName: 'メニュー',
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
  },
  async mounted() {
    await this.ensureUserAndMasters()
    if (!this.has_role_admin) {
      location.href = '/'
    }
  },
  mixins: [masterMixin],
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
